(function () {

  console.log("Microsoft UET initialisation");

  window.uetq = window.uetq || [];

  (function(w,d,t,r,u){
    var f,n,i;

    w[u]=w[u]||[];

    f=function(){
      var o={
        ti:"187260373",
        disableAutoPageView:true,
        enableAutoSpaTracking:false
      };

      o.q=w[u];
      w[u]=new UET(o);
      w[u].push("pageLoad");
    };

    n=d.createElement(t);
    n.src=r;
    n.async=1;

    n.onload=n.onreadystatechange=function(){
      var s=this.readyState;

      if(!s || s==="loaded" || s==="complete"){
        f();
        n.onload=n.onreadystatechange=null;
      }
    };

    i=d.getElementsByTagName(t)[0];
    i.parentNode.insertBefore(n,i);

  })(window,document,"script","https://bat.bing.com/bat.js","uetq");

    document.addEventListener('on:cart:add', function(event) {

  console.log("on:cart:add détail complet :", event.detail);

  window.uetq.push('event', 'add_to_cart');

});

document.addEventListener('click', function(event) {

  const catalogButton = event.target.closest('.catalog-form__submit-button');

  if (catalogButton) {
    console.log("Téléchargement catalogue détecté");

    window.uetq.push('event', 'Téléchargement catalogue');
  }

});

})();